export enum EProgressionPaquet {
    NonCommence = 0,
    EnCours = 1,
    Complete = 2
}